import { Form, FormContentRef } from "@/components/Form"
import { FormRenderMode, FormType } from "@/components/Form/types"
import { useAppSelector } from "@/core/app/hooks"
import FORM_CONSTANT from "@/core/app/slices/uassist/form.constant"
import { RootState } from "@/core/app/store"
import { stageControl } from "@/gluelayer"
import React, { useMemo, useRef, forwardRef } from "react"
import { useTranslation } from "react-i18next"

interface RxFormProps {
  patientId: string
  caseId: string
  needToSubmit: boolean
  isRetainer: boolean
  stageControl: any
  currentReviewNum: number
  actionType: 'edit' | 'review' | 'success' | 'smartRX' | ''
  setShowButton: (show: boolean) => void
  setActionType: (type: 'edit' | 'review' | 'success' | 'smartRX' | '') => void
  unlockFunc: () => void
}

const RxForm = forwardRef<FormContentRef, RxFormProps>((
  {
    patientId,
    caseId,
    currentReviewNum,
    needToSubmit,
    isRetainer,
    stageControl,
    actionType,
    setShowButton,
    setActionType,
    unlockFunc,
  }, ref) => {

  const { t } = useTranslation("common")
  const { uAssistOrders } = useAppSelector((state: RootState) => state.orderService)

  
  const formDisplayDetails = useMemo(() => {
    let details = {
      formTitle: null,
      formDescription: null,
    }
    
    if (needToSubmit) {
      // RIGHT Side Form Popup
      if (actionType == "edit") {
        details.formTitle = isRetainer ? t("uassist.selfPlanned.retainer") : null
        details.formDescription = null
      } else {
        // Summary
        
        details.formTitle = isRetainer
            ? t("uassist.selfPlanned.retainerSummary")
            : t("uassist.selfPlanned.prescriptionSummary")
        
        details.formDescription = t("uassist.summary.summarydesc")
      }
    } else {
      // LEFT Side Form Popup
      if(actionType == "review"){
        details = {
          formTitle:
            uAssistOrders && uAssistOrders[currentReviewNum]?.uassistRound
              ? t("uassist.uDC.refinementSummary")
              : isRetainer
              ? t("uassist.uDC.retainerSummary")
              : t("uassist.uDC.prescriptionSummary"),
          
          //  t("uassist.summary.summarydesc") is wrong text in this context
          // hiding description, until confirmation
          formDescription: null, 
        }
      }
    }
    return details
  }, [actionType, needToSubmit, isRetainer, uAssistOrders, currentReviewNum])

  return (
    <>
      <Form
        ref={ref}
        details={{
          patientId,
          caseId,
          formType: FormType.UASSIST,

          // if right side form, determine the form name
          // for left side form fetch by uassist_round
          formName: needToSubmit
            ? isRetainer
              ? FORM_CONSTANT.RETAINER
              : stageControl.getMaxStageNodeIndex() > 0 && needToSubmit
              ? FORM_CONSTANT.PRESCRIPTION_2
              : FORM_CONSTANT.PRESCRIPTION
            : null,
          uassistRound: currentReviewNum,
          fetchSavedData: true,
          saveId: null,
          displayMeta: formDisplayDetails,
        }}
        mode={
          needToSubmit && actionType === "edit"
            ? FormRenderMode.EDIT
            : FormRenderMode.SUMMARY
        }
        setCurrentFormType={(formType) => {
          setShowButton(formType !== "SMARTRX")
        }}
        onFormSaved={() => {
          setActionType("review")
          // upload dental chart ?
        }}
        showValidationErrors={false}
        unlockFunc={unlockFunc}
      />
    </>
  )
})

export default RxForm
